import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router";
import apiClient from "../../ApiEndpoint/apiClient";
import { Select, Spin, Button } from "antd";
import "./filterbar.css";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import apiUrl from "../../ApiEndpoint/config";
import { BehaviorSubject, from } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import building from '../../assets/building.png';
import qs from 'qs';
import { toast } from 'react-toastify';
import RefineSearch from "../RefineSearch/refinesearch.js";


const { Option } = Select;

const FilterBar = ({ updateMapMarkers, filterState, plantCoordinates = [], projectCoordinates = [] }) => {
    const [sicIndustryData, setSicIndustryData] = useState([]);
    const [sicCodes, setSicCodes] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [cities, setCities] = useState([]);
    const [counties, setCounties] = useState([]);
    const [states, setStates] = useState([]);
    const [facilities, setFacilities] = useState([]);
    const [groups, setGroups] = useState([]);
    const [selectedSICIndustryPairs, setSelectedSICIndustryPairs] = useState([]);

    const [selectedSIC, setSelectedSIC] = useState(null);
    const [selectedIndustry, setSelectedIndustry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedGroupObj, setSelectedGroupObj] = useState(null);

    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedCityObj, setSelectedCityObj] = useState(null);
    const [selectedCounty, setSelectedCounty] = useState(null);
    const [selectedCountyObj, setSelectedCountyObj] = useState(null);
    const [selectedFacility, setSelectedFacility] = useState(null);
    const [facilitiesLoaded, setFacilitiesLoaded] = useState(false);
    const [debounceDuration] = useState(1000);

    const { setRegisterid, setGroupInfo, setProjectId } = useContext(RegisterIdContext);
    const { setViolationData } = useContext(RegisterIdContext);
    const { setRegisteridContext, setGroupName, setSicCodeContext, setIndurstryContext, state, county, city, countyObj, cityObj, setStateContext, setCountyContext, setCityContext, setMarkerLoc } = useContext(RegisterIdContext);
    const { setCityLat, setCityLng, setStateLat, setStateLng, setCountyLat, setCountyLng, setFacLat, setFacLng, setSelectedRegistryId, refineSearchEPAFiltersData } = useContext(RegisterIdContext);
    const { showFilterBar, setShowFilterBar, setfaciltyGroupName, setRefineSearchActive } = useContext(RegisterIdContext);
    const navigate = useNavigate();
    //FOr facility value interpolation
    const latestFacilityDataRef = useRef(null);
    const [localFilterState, setLocalFilterState] = useState(filterState);
    const hasFilterState = !!(localFilterState && Object.keys(localFilterState).length > 0);
    const { setSelectedRefineMenu, setRefineSearchModalVisible, refineSearchActive, setIsFacilitiesEmpty, showProjectTable, setShowProjectTable } = useContext(RegisterIdContext);
    const [loadingStates, setLoadingStates] = useState(false);




    //Loading filter data
    const searchIndustrySubject = useRef(new BehaviorSubject(''));
    const searchSICSubject = useRef(new BehaviorSubject(''));
    const searchFacilitySubject = useRef(new BehaviorSubject(''));
    const searchStateSubject = useRef(new BehaviorSubject(''));
    const searchCountySubject = useRef(new BehaviorSubject(''));
    const searchCitySubject = useRef(new BehaviorSubject(''));
    const searchGroupSubject = useRef(new BehaviorSubject(''));

    const [industryFocused, setIndustryFocused] = useState(false);
    const [sicFocused, setSicFocused] = useState(false);
    const [groupFocused, setGroupFocused] = useState(false);
    const [stateFocused, setStateFocused] = useState(false);
    const [countyFocused, setCountyFocused] = useState(false);
    const [cityFocused, setCityFocused] = useState(false);
    const [facilityFocused, setFacilityFocused] = useState(false);

    //Get facility data on initial load or when it come from navigation changes
    useEffect(() => {
        if (!localFilterState || !localFilterState.registryId && facilitiesLoaded) return;


        setSelectedFacility(localFilterState.registryId);
        const fetchFacility = async () => {
            //await handleFacilityChange(localFilterState.registryId);
            // Delay before resetting
            setTimeout(() => {
                setLocalFilterState(null);
                setFacilitiesLoaded(false);
            }, 1000); //  delay — adjust as needed
        };

        fetchFacility();
    }, [localFilterState?.registryId, facilitiesLoaded]);


    // Industry Subscription
    useEffect(() => {
        if (!industryFocused) return;
        const sub = searchIndustrySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText && { industry_type: searchText }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(selectedGroup && { group_name: selectedGroup }),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        setLoadingStates(true);
                        const response = await apiClient.get(`${apiUrl}/sic_list`, { params });
                        return response;
                    } catch {
                        return { data: { sic_list_data: [] } };
                    } finally {
                        setLoadingStates(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.sic_list_data || [];
                setSicIndustryData(data);
                setIndustries(data);
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, industryFocused, refineSearchEPAFiltersData]);
    // SIC Subscription
    useEffect(() => {
        const sub = searchSICSubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText && { sic_code: searchText }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(selectedGroup && { group_name: selectedGroup }),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        const response = await apiClient.get(`${apiUrl}/sic_list`, { params });
                        return response;
                    } catch {
                        return { data: { sic_list_data: [] } };
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.sic_list_data || [];
                setSicIndustryData(data);
                setSicCodes(data);
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, selectedFacility, selectedGroup, selectedState, selectedCounty, selectedCity, refineSearchEPAFiltersData]);
    // Group Subscription
    useEffect(() => {
        if (!groupFocused) return;
        const sub = searchGroupSubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 50,
                            ...(searchText && { group_name: searchText }),
                            ...(selectedSIC && { sic_code: selectedSIC }),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        setLoadingStates(true);
                        const response = await apiClient.get(`${apiUrl}/group-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { group_list_data: [] } };
                    } finally {
                        setLoadingStates(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.group_list_data || [];
                setGroups(data);
                if (selectedFacility && data.length === 1) {
                    setGroupInfo(data[0])
                }
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, groupFocused, refineSearchEPAFiltersData]);

    // State Subscription
    useEffect(() => {
        //if (!stateFocused) return;
        const sub = searchStateSubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText && { fac_state: searchText }),
                            ...(selectedSIC && { sic_code: selectedSIC }),
                            ...(selectedGroup && { group_name: selectedGroup }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        setLoadingStates(true);
                        const response = await apiClient.get(`${apiUrl}/state-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { state_list_data: [] } };
                    } finally {
                        setLoadingStates(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.state_list_data || [];
                setStates(data);
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, stateFocused, refineSearchEPAFiltersData]);

    // County Subscription
    useEffect(() => {
        if (!countyFocused) return;
        const sub = searchCountySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(searchText && { fac_county: searchText }),
                            ...(selectedSIC && { sic_code: selectedSIC }),
                            ...(selectedGroup && { group_name: selectedGroup }),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        setLoadingStates(true);
                        const response = await apiClient.get(`${apiUrl}/counties-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { counties_list_data: [] } };
                    } finally {
                        setLoadingStates(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.counties_list_data || [];
                setCounties(data);
                if (selectedFacility && data.length === 1) {
                    setSelectedCountyObj(JSON.stringify(data[0]))
                }
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, countyFocused, refineSearchEPAFiltersData]);

    // City Subscription
    useEffect(() => {
        if (!cityFocused) return;
        const sub = searchCitySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 50,
                            ...(searchText && { fac_city: searchText }),
                            ...(selectedSIC && { sic_code: selectedSIC }),
                            ...(selectedGroup && { group_name: selectedGroup }),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedFacility && { registry_id: selectedFacility }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        setLoadingStates(true);
                        const response = await apiClient.get(`${apiUrl}/cities-list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { cities_list_data: [] } };
                    } finally {
                        setLoadingStates(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.cities_list_data || [];
                setCities(data);
                if (selectedFacility && data.length === 1) {
                    setSelectedCityObj(JSON.stringify(data[0]))
                }

            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, cityFocused, selectedFacility, refineSearchEPAFiltersData]);

    //Facility Subscription

    useEffect(() => {
        if (!facilityFocused && localFilterState?.registryId == null) return;
        const sub = searchFacilitySubject.current.pipe(
            debounceTime(debounceDuration),
            distinctUntilChanged(),
            switchMap(searchText =>
                from((async () => {
                    try {
                        const params = {
                            offset: 0,
                            limit: 100,
                            ...(localFilterState?.registryId
                                ? { registry_id: localFilterState.registryId }
                                : searchText ? { fac_name: searchText } : {}),
                            ...(selectedSIC && { sic_code: selectedSIC }),
                            ...(selectedGroup && { group_name: selectedGroup }),
                            ...(selectedState && { fac_state: selectedState }),
                            ...(selectedCounty && { fac_county: selectedCounty }),
                            ...(selectedCity && { fac_city: selectedCity }),
                            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
                        };
                        setLoadingStates(true);
                        const response = await apiClient.get(`${apiUrl}/facilities_list`, {
                            params,
                            paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                        });
                        return response;
                    } catch {
                        return { data: { facilities_list_data: [] } };
                    } finally {
                        setLoadingStates(false); // Stop loader
                    }
                })())
            )
        ).subscribe({
            next: (res) => {
                const data = res.data?.facilities_list_data || [];
                setFacilities(data);
                if (data.length === 1 && localFilterState?.registryId) {
                    setFacilitiesLoaded(true);
                }
            }
        });

        return () => sub.unsubscribe();
    }, [apiUrl, selectedFacility, facilityFocused, refineSearchEPAFiltersData]);


    useEffect(() => {
        if (state) setSelectedState(state);
    }, [state]);

    useEffect(() => {
        if (county) {
            setSelectedCounty(county);
            setSelectedCountyObj(JSON.stringify(countyObj));
        }
    }, [county]);

    useEffect(() => {
        if (city) {
            setSelectedCity(city);
            setSelectedCityObj(JSON.stringify(cityObj));
        }
    }, [city]);
    //function for reset the dropdownlist with the autosuggestion

    useEffect(() => {
        if (hasFilterState) return;

        // Set context values
        setSicCodeContext(selectedSIC);
        setIndurstryContext(selectedIndustry);
        setGroupName(selectedGroup);
        setStateContext(selectedState);
        setCountyContext(selectedCounty);
        setCityContext(selectedCity);
        setRegisteridContext(selectedFacility);
        setMarkerLoc(selectedFacility)
    }, [
        selectedSIC,
        selectedIndustry,
        selectedFacility,
        selectedGroup,
        selectedState,
        selectedCity,
        selectedCounty,
        hasFilterState
    ]);



    //Fetch State Data and update map markers initially
    useEffect(() => {
        if (hasFilterState) return;
        dispatchByPriority();
    }, [selectedState, selectedCounty, selectedCity, selectedFacility, selectedGroup, selectedSIC, hasFilterState, refineSearchEPAFiltersData]);

    const dispatchByPriority = async () => {
        if (selectedFacility) return await handleFacilityChange(selectedFacility);
        if (selectedCity) return await handleCityChange(selectedCityObj);
        if (selectedCounty) return await handleCountyChange(selectedCountyObj);
        if (selectedState) return await handleStateChange(selectedState);
        return await fetchStatewiseCount();
    };






    //fetching the values of state and county and city for the facility values interpolation
    useEffect(() => {
        const { facilityCounty, facilityState, facilityCity } = latestFacilityDataRef.current || {};

        if (counties?.length && cities?.length && facilityCounty && facilityState && facilityCity) {
            const matchedCountyObj = counties.find(
                c => c.county === facilityCounty && c.state === facilityState
            );
            if (matchedCountyObj) {
                setSelectedCountyObj(JSON.stringify(matchedCountyObj));
            }

            const matchedCityObj = cities.find(
                c => c.city === facilityCity && c.county === facilityCounty && c.state_code === facilityState
            );
            if (matchedCityObj) {
                setSelectedCityObj(JSON.stringify(matchedCityObj));
            }
        }
    }, [counties, cities]);



    const fetchStatewiseCount = async () => {
        const params = {
            offset: 0,
            limit: 100, // Pass the page size to the API
            ...(selectedSIC?.length > 0 && { sic_code: selectedSIC }),
            ...(selectedGroup && { group_name: selectedGroup }),
            ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
            ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
            ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
            ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
            ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
            ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
            ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
            ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
            ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type })
        };

        try {
            const response = await apiClient.get(`${apiUrl}/state_facility_count`, {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });

            let data = response.data?.data || [];
            updateMapMarkers(data); // Set initial markers without static point
        } catch (error) {
            console.error("Error fetching state data:", error);
        }
    };


    const handleSICChange = async (value) => {
        const selectedSICs = Array.isArray(value) ? value : [];

        if (selectedSICs.length > 5) {
            toast.warning("You can select up to 5 SIC codes only.");
            return;
        }

        const prevSelectedSICs = Array.isArray(selectedSIC) ? selectedSIC : [];

        // Find added & removed SICs
        const addedSICs = selectedSICs.filter(sic => !prevSelectedSICs.includes(sic));
        const removedSICs = prevSelectedSICs.filter(sic => !selectedSICs.includes(sic));

        // Clone current pairs
        let updatedPairs = Array.isArray(selectedSICIndustryPairs)
            ? [...selectedSICIndustryPairs]
            : [];

        // Add new SIC-to-Industry pairs
        addedSICs.forEach(sic => {
            const match = sicIndustryData?.find(item => item.SIC_CODE === sic);
            if (match) {
                updatedPairs.push({
                    SIC_CODE: match.SIC_CODE,
                    Industry_Title: match.Industry_Title
                });
            }
        });

        // Remove pairs for unselected SICs
        updatedPairs = updatedPairs.filter(pair => !removedSICs.includes(pair.SIC_CODE));

        // Extract unique industries
        const uniqueIndustries = [
            ...new Set(updatedPairs.map(pair => pair.Industry_Title))
        ];

        // Update state
        setSelectedSIC(selectedSICs);
        setSelectedSICIndustryPairs(updatedPairs);
        setSelectedIndustry(uniqueIndustries);
        setSicCodeContext(selectedSICs);
        setIndurstryContext(null);
        setSelectedRegistryId(null);


    };


    const handleIndustryChange = async (value) => {
        const selectedIndustries = Array.isArray(value) ? value : [];

        if (selectedIndustries.length > 5) {
            toast.warning("You can select up to 5 industries only.");
            return;
        }

        const prevIndustries = Array.isArray(selectedIndustry) ? selectedIndustry : [];
        let updatedPairs = Array.isArray(selectedSICIndustryPairs) ? [...selectedSICIndustryPairs] : [];
        const industryData = Array.isArray(sicIndustryData) ? sicIndustryData : [];

        // Find removed industries (in previous but not current)
        const removedIndustries = prevIndustries.filter(
            ind => !selectedIndustries.includes(ind)
        );

        // Remove pairs for deselected industries
        updatedPairs = updatedPairs.filter(
            pair => !removedIndustries.includes(pair.Industry_Title)
        );

        // Find industries not already in the pair list
        const addedIndustries = selectedIndustries.filter(
            ind => !updatedPairs.some(pair => pair.Industry_Title === ind)
        );

        // Add new pairs for newly selected industries (if available in current data)
        addedIndustries.forEach(ind => {
            const match = industryData.find(item => item.Industry_Title === ind);
            if (match) {
                updatedPairs.push({
                    SIC_CODE: match.SIC_CODE,
                    Industry_Title: match.Industry_Title
                });
            }
        });

        // Derive matched SICs from updated pairs
        const matchedSICs = updatedPairs
            .filter(pair => selectedIndustries.includes(pair.Industry_Title))
            .map(pair => pair.SIC_CODE);

        // Update state
        setSelectedIndustry(selectedIndustries);
        setSelectedSIC([...new Set(matchedSICs)]);
        setSelectedSICIndustryPairs(updatedPairs);
        setSicCodeContext(null);
        setIndurstryContext(selectedIndustries);
        setSelectedRegistryId(null);
        searchIndustrySubject.current.next("");


    };



    // Fetch state Data and plot

    const handleStateChange = async (value) => {

        updateMapMarkers([])
        // 🔁 Reset selected row on dropdown change
        setSelectedRegistryId(null);

        let Geocodes = states.find(item => item.state === value) || null;
        setSelectedState(value || null);
        setStateContext(value || null);
        searchStateSubject.current.next("");
        // Clear county and city selections when state changes
        setSelectedCounty(null);
        setSelectedCity(null);
        setSelectedFacility(null);
        setCounties([]); // Clear county dropdown options
        setCities([]);
        setFacilities([]);   // Clear city dropdown options

        setCountyLat(null)
        setCountyLng(null)
        setCityLat(null)
        setCityLng(null)
        const stateLat = Geocodes ? parseFloat(Geocodes.sate_latitude) : null;
        const stateLng = Geocodes ? parseFloat(Geocodes.sate_longitude) : null;
        setStateLat(stateLat)
        setStateLng(stateLng)


        if (value) {

            // Construct API URL with optional SIC code
            const params = {
                state_code: value,
                ...(selectedSIC?.length && { sic_code: selectedSIC }), // array of strings/numbers
                ...(selectedGroup && { group_name: selectedGroup }),
                ...(selectedIndustry?.length && { industry: selectedIndustry }),
                ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type }),
            };

            apiClient.get(`${apiUrl}/county_facility_count`, {
                params,
                paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
            })
                .then((response) => {
                    const data = response.data?.data || [];
                    updateMapMarkers(data); // render map markers
                })
                .catch((error) => {
                    console.error("Error fetching county data:", error);
                });

        }
    };




    //Refresh homestart home icon logic
    const handleReload = () => {
        setFacilitiesLoaded(false);
        navigate("/smart-prospecting/data"); // No state passed
        setTimeout(() => {
            window.location.href = "/smart-prospecting/data"; // Forces reload and clears state
        }, 50);
    };


    //Fetch County Data and plot

    const handleCountyChange = async (countyvalue) => {
        const Countygeocodes = countyvalue ? JSON.parse(countyvalue) : {};

        let value = Countygeocodes?.county != null ? Countygeocodes?.county : null;

        updateMapMarkers([])
        // 🔁 Reset selected row on dropdown change
        setSelectedRegistryId(null);

        setSelectedCountyObj(countyvalue);
        setSelectedCounty(value || null);
        setCountyContext(value || null);
        searchCountySubject.current.next("");

        // Clear county and city selections when state changes

        setSelectedCity(null);
        setSelectedFacility(null);

        setCities([]);
        setFacilities([]);   // Clear city dropdown options


        setCityLat(null)
        setCityLng(null)

        // Extract county latitude and longitude
        const countyLat = Countygeocodes?.county_latitude != null ? parseFloat(Countygeocodes.county_latitude) : null;
        const countyLng = Countygeocodes?.county_longitude != null ? parseFloat(Countygeocodes.county_longitude) : null;

        setCountyLat(countyLat)
        setCountyLng(countyLng)

        if (value) {
            const stateParam = selectedState ? selectedState : Countygeocodes?.state;
            const params = {
                county_name: value,
                ...(stateParam && { state_code: stateParam }),
                ...(selectedSIC?.length && { sic_code: selectedSIC }),
                ...(selectedGroup && { group_name: selectedGroup }),
                ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type }),
            };

            if (!selectedState) setStateContext(stateParam)
            // Construct API URL with optional SIC code
            let apiUrlWithParams = `${apiUrl}/city_facility_count`;
            apiClient.get(apiUrlWithParams, { params, paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }) })
                .then(response => {
                    const data = response.data?.data || [];


                    // Pass data and lat/lng to DataPage
                    updateMapMarkers(data);
                })
                .catch(error => console.error("Error fetching city data:", error));
        }
    };


    //Fetch City Data and plot
    const handleCityChange = async (cityvalue) => {


        const Citygeocodes = cityvalue ? JSON.parse(cityvalue) : {};
        let value = Citygeocodes?.city != null ? Citygeocodes.city : null;
        setSelectedCity(value || null);
        setCityContext(value || null);
        setSelectedCityObj(cityvalue)
        searchCitySubject.current.next("");

        // 🔁 Reset selected row on dropdown change
        setSelectedRegistryId(null);
        // Clear county and city selections when state changes
        setSelectedFacility(null);
        setFacilities([]);   // Clear city dropdown option
        updateMapMarkers([])
        // Extract city latitude and longitude safely
        const cityLat = Citygeocodes?.city_latitude != null ? parseFloat(Citygeocodes.city_latitude) : null;
        const cityLng = Citygeocodes?.city_longitude != null ? parseFloat(Citygeocodes.city_longitude) : null;


        setCityLat(cityLat)
        setCityLng(cityLng)
        setFacLat(null)
        setFacLng(null)
        if (value) {
            const stateParam = selectedState ? selectedState : Citygeocodes?.state_code;
            const countyParam = selectedCounty ? selectedCounty : Citygeocodes?.county;
            const params = {
                city: value,
                ...(stateParam && { state: stateParam }),
                ...(countyParam && { county: countyParam }),
                ...(selectedSIC?.length > 0 && { sic_code: selectedSIC }),
                ...(selectedGroup && { group_name: selectedGroup }),
                ...(refineSearchEPAFiltersData.sdwa_major_viol && { sdwa_major_viol: refineSearchEPAFiltersData.sdwa_major_viol }),
                ...(refineSearchEPAFiltersData.cwa_major_viol && { cwa_major_viol: refineSearchEPAFiltersData.cwa_major_viol }),
                ...(refineSearchEPAFiltersData.rcra_major_viol && { rcra_major_viol: refineSearchEPAFiltersData.rcra_major_viol }),
                ...(refineSearchEPAFiltersData.permit_comp_status && { permit_comp_status: refineSearchEPAFiltersData.permit_comp_status }),
                ...(refineSearchEPAFiltersData.min_avg_flow && { min_avg_flow: refineSearchEPAFiltersData.min_avg_flow }),
                ...(refineSearchEPAFiltersData.min_dmr && { min_dmr: refineSearchEPAFiltersData.min_dmr }),
                ...(refineSearchEPAFiltersData.min_design_flow && { min_design_flow: refineSearchEPAFiltersData.min_design_flow }),
                ...(refineSearchEPAFiltersData.major_minor_status && { major_minor_status: refineSearchEPAFiltersData.major_minor_status }),
                ...(refineSearchEPAFiltersData.facility_type && { facility_type: refineSearchEPAFiltersData.facility_type }),
            };

            if (!selectedState) setStateContext(stateParam)
            if (!selectedCounty) setCountyContext(countyParam)

            let apiUrlWithParams = `${apiUrl}/facility_details`;

            apiClient.get(apiUrlWithParams, { params, paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }) })
                .then(response => {
                    const data = response.data?.data || [];

                    // Pass data and lat/lng to DataPage
                    updateMapMarkers(data);
                })
                .catch(error => console.error("Error fetching city data:", error));
        }

    };


    //Fetch Facility Data and plot
    const handleFacilityChange = async (value) => {
        try {
            let Facilitygeocodes = facilities.find(item => item.registry_id === value) || null;
            setSelectedFacility(value || null);
            setRegisteridContext(value)
            searchFacilitySubject.current.next("");
            setRegisterid(null)
            // setMarkerLoc(value)

            // 🔁 Reset selected row on dropdown change
            setSelectedRegistryId(null);
            // Extract latitude and longitude
            const facLat = Facilitygeocodes?.fac_latitude != null ? parseFloat(Facilitygeocodes?.fac_latitude) : null;
            const facLng = Facilitygeocodes?.fac_longitude != null ? parseFloat(Facilitygeocodes?.fac_longitude) : null;

            setFacLat(facLat)
            setFacLng(facLng)

            if (value) {
                // Fetch facility info
                const facilityResponse = await apiClient.get(`${apiUrl}/facility_info?registry_id=${value}`);
                const facilityData = facilityResponse.data?.data || [];

                setRegisterid(facilityData);
                setfaciltyGroupName(facilityData?.[0]?.group_names)

                // Pass data and lat/lng to DataPage
                updateMapMarkers(facilityData);

                // Fetch facility violations
                //const id = '110009057849'
                const violationResponse = await apiClient.get(`${apiUrl}/npdes_facility_violations?registry_id=${value}`);
                const violationData = violationResponse.data ? violationResponse.data : null; // Set to null if undefined
                setViolationData(violationData)


                // Handle violations data as needed
            }
        } catch (error) {
            console.error("Error in handleFacilityChange:", error);
        }
    };

    const handleGroupChange = async (groupvalue) => {
        const groupInfo = groupvalue ? JSON.parse(groupvalue) : {};
        // 🔁 Reset selected row on dropdown change
        setSelectedRegistryId(null);
        setGroupInfo(groupInfo)
        let value = groupInfo?.Group_name != null ? groupInfo?.Group_name : null;
        setSelectedGroup(value)
        setGroupName(value)
        setProjectId(null)
        searchGroupSubject.current.next("");
        setRegisterid(null)
        setMarkerLoc(null)
        setShowProjectTable(true)
    }


    const handleChatPage = () => {
        setStateContext(null);
        setCountyContext(null);
        setCityContext(null);
        setRegisteridContext(null);
        setRegisterid(null);
        // navigate("/");
        window.location.href = "/";
    };

    const handleClick = () => {
        setShowFilterBar(false);
        setLocalFilterState(null);
        setFacilitiesLoaded(false);
        updateMapMarkers([]);
        setIsFacilitiesEmpty(false)
        setRegisteridContext(null);
        setSicCodeContext(null);
        setIndurstryContext(null);
        setStateContext(null);
        setCountyContext(null);
        setCityContext(null);
        setGroupName(null);
        setRefineSearchActive(false)
    };




    return (
        <div className="Container">
            <div className="row">
                <div className="col-11 pb-2">
                    {/* Home icon */}

                    <i onClick={handleChatPage}
                        className="bi bi-house-fill"
                        style={{ fontSize: "1.5rem", cursor: "pointer", color: "#75748B", paddingRight: "3px", position: "relative", top: "4px" }}
                    ></i>
                    <i onClick={handleReload}
                        className="bi bi-arrow-clockwise"
                        style={{ fontSize: "1.5rem", cursor: "pointer", color: "#75748B", paddingRight: "4px", position: "relative", top: "4px" }}
                    ></i>
                    {/* Industry Dropdown */}
                    <Select
                        mode="multiple"
                        maxTagCount={1}
                        className={`filter-select ${refineSearchActive ? "hidden" : ""}`}
                        showSearch
                        placeholder="Select Industry"
                        value={selectedIndustry}
                        onChange={handleIndustryChange}
                        onSearch={(value) => searchIndustrySubject.current.next(value)}
                        onClear={() => searchIndustrySubject.current.next("")}
                        onFocus={() => setIndustryFocused(true)}
                        onBlur={() => setIndustryFocused(false)}
                        allowClear
                        filterOption={false}
                        notFoundContent={loadingStates ? <Spin size="small" /> : null}
                    >
                        {industries.map((industry) => (
                            <Option
                                key={industry.Industry_Title}
                                value={industry.Industry_Title}
                            >
                                {industry.Industry_Title}
                            </Option>
                        ))}
                    </Select>

                    {/* SIC Code Dropdown */}
                    <div className="sic-hidden" style={{ display: 'none' }}>
                        <Select
                            className="filter-select fixed-select"
                            mode="multiple"
                            maxTagCount={1}
                            showSearch
                            placeholder="Select SIC Code"
                            value={selectedSIC}
                            onChange={handleSICChange}
                            onSearch={(value) => searchSICSubject.current.next(value)}
                            onClear={() => searchSICSubject.current.next("")}
                            allowClear
                            filterOption={false}
                        >
                            {sicCodes.map((code) => (
                                <Option key={code.SIC_CODE} value={code.SIC_CODE}>
                                    {code.SIC_CODE}
                                </Option>
                            ))}
                        </Select>
                    </div>

                    {/* Group Dropdown */}
                    <Select
                        className={`filter-select ${refineSearchActive ? "hidden" : ""}`}
                        showSearch
                        placeholder="Select Parent Company"
                        value={selectedGroup}
                        onChange={handleGroupChange}
                        onSearch={(value) => searchGroupSubject.current.next(value)}
                        onClear={() => searchGroupSubject.current.next("")}
                        onFocus={() => setGroupFocused(true)}
                        onBlur={() => setGroupFocused(false)}
                        allowClear
                        notFoundContent={loadingStates ? <Spin size="small" /> : null}
                    >
                        {groups.map((group, index) => (
                            <Option key={`${index}_${group.Group_name}`} value={JSON.stringify(group)}>
                                {group?.Group_name}
                            </Option>
                        ))}
                    </Select>

                    {/* State Dropdown */}

                    <Select
                        className={`filter-select ${refineSearchActive ? "hidden" : ""}`}
                        showSearch
                        placeholder="Select State"
                        value={selectedState} // Should be FAC_STATE
                        onChange={handleStateChange}
                        onSearch={(value) => searchStateSubject.current.next(value)}
                        onClear={() => searchStateSubject.current.next("")}
                        onFocus={() => setStateFocused(true)}
                        onBlur={() => setStateFocused(false)}
                        allowClear
                        optionFilterProp="children" // Ensures search filters by STATE_NAME dont delete
                        notFoundContent={loadingStates ? <Spin size="small" /> : null}
                    >
                        {states.map((state) => (
                            <Option key={state.state} value={state.state}>
                                {state.state_name}, {state.state}
                            </Option>
                        ))}
                    </Select>

                    {/* County Dropdown */}

                    <Select
                        className={`filter-select ${refineSearchActive ? "hidden" : ""}`}
                        showSearch
                        placeholder="Select County"
                        value={selectedCounty}
                        onChange={handleCountyChange}
                        onSearch={(value) => searchCountySubject.current.next(value)}
                        onClear={() => searchCountySubject.current.next("")}
                        onFocus={() => setCountyFocused(true)}
                        onBlur={() => setCountyFocused(false)}
                        allowClear
                        notFoundContent={loadingStates ? <Spin size="small" /> : null}
                    >
                        {counties.map((county, index) => (
                            <Option
                                key={`${index}_${county.county}`}
                                value={JSON.stringify(county)}
                            >
                                {county.county},{county.state}
                            </Option>
                        ))}
                    </Select>

                    {/* city Dropdown */}

                    <Select
                        className={`filter-select ${refineSearchActive ? "hidden" : ""}`}
                        showSearch
                        placeholder="Select City"
                        value={selectedCity}
                        onChange={handleCityChange}
                        onSearch={(value) => searchCitySubject.current.next(value)}
                        onClear={() => searchCitySubject.current.next("")}
                        onFocus={() => setCityFocused(true)}
                        onBlur={() => setCityFocused(false)}
                        allowClear
                        filterOption={false}
                        notFoundContent={loadingStates ? <Spin size="small" /> : null}
                    >

                        {cities.map((city, index) => (
                            <Option key={`${index}_${city.city}`} value={JSON.stringify(city)}>
                                {city.city},{city.state_code}
                            </Option>
                        ))}
                    </Select>

                    {/* Facility Dropdown */}

                    <Select
                        className={`filter-select facility-dropdown ${refineSearchActive ? "hidden" : ""}`}
                        showSearch
                        placeholder="Select Facility"
                        value={selectedFacility}
                        onChange={handleFacilityChange}
                        onSearch={(value) => searchFacilitySubject.current.next(value)}
                        onClear={() => searchFacilitySubject.current.next("")}
                        onFocus={() => setFacilityFocused(true)}
                        onBlur={() => setFacilityFocused(false)}
                        allowClear
                        filterOption={false}
                        notFoundContent={loadingStates ? <Spin size="small" /> : null}
                    >
                        {facilities.map((facility) => (
                            <Option key={facility.registry_id} value={facility.registry_id}>
                                {facility.facility_name} - {facility.state_code}
                            </Option>
                        ))}
                    </Select>

                    {/* Facility Dropdown */}


                    <Button
                        type="primary"
                        onClick={() => {
                            setSelectedRefineMenu("IIR Data Source"); // still set the menu if needed
                            setRefineSearchModalVisible(true); // show the modal
                        }}
                    >
                        Refine Search
                    </Button>
                    <RefineSearch plantCoordinates={plantCoordinates} projectCoordinates={projectCoordinates} />

                </div>
                <div className="col-1 p-0">
                    <div className="building-icon" onClick={handleClick}>
                        <img
                            src={building} // Use two image variants
                            alt="Building Icon"
                            title={showFilterBar ? "Show building view" : "Show Facility view"}
                            style={{
                                width: "26px",
                                height: "28px",
                                cursor: "pointer",
                                marginLeft: "40px"
                            }}
                        />
                        <div>
                            <p className="m-0" style={{ fontSize: '12px', fontWeight: '900', color: 'black' }}>Switch to Building view</p>
                        </div>

                    </div>
                </div>


            </div>
        </div >

    );
};

export default FilterBar;







